<template>
  <v-dialog v-model="dialog" max-width="400" @click:outside="close" >
    <v-card>
      <v-card-title class="pt-4">Delete project</v-card-title>
      <v-card-text v-if="project" class="pl-4 pt-0">
        Delete project <strong>{{ project.name }}</strong>?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            :loading="loading"
            color="red darken-1"
            text
            @click="deleteObj()"
        >
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
  name: "ProjectDeleteDialog",
  data: () => ({}),
  computed: {
    ...mapState('project', {
      dialog: state => state.projectDeleteDialog,
      project: state => state.currentProject,
      loading: state => state.writeLoading,
    }),
  },
  methods: {
    ...mapActions('project', {
      toggleDeleteProjectDialog: "toggleDeleteProjectDialog",
      deleteProject: "deleteProject",
    },),
    close() {
      this.toggleDeleteProjectDialog();
    },
    async deleteObj() {
      await this.deleteProject();
      this.close()
    }
  },

}
</script>

